<template>
  <div class="generate_container">
    <a-modal class="gufiiguy" title="生成报价" :visible="generateVisible" @cancel="closeVisible" width="70%">
      <!-- 步骤条 -->
      <div class="generate_top">
        <a-steps :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
      </div>
      <div class="steps-content">
        <div v-if="type == 0" class="stepsCenter">
          <div>
            <a-button class="box" v-for="item in categoryNameList" :key="item.id" @click="chooseCategoryName(item)" :disabled="item.id == 5">
              <span>[{{ item.abbreviation }}] {{ item.categoryName }}</span>
            </a-button>
          </div>
        </div>
        <!-- 第二步 -->
        <div v-if="type == 1">
          <Information v-if="this.rowData.id == 1" :propRowData="propRowData" :UUID="UUID" @transmit="transmit" @getIndustry="getIndustry" ref="baseRef" :rowData="rowData" ></Information>
          <EnvironmrntInformation v-else-if="this.rowData.id == 2 || this.rowData.id == 3" :propRowData="propRowData" :rowData="rowData" @chooseCategory="chooseCategory" ref="environmentRef"></EnvironmrntInformation>
          <PublicEnvirenment v-if="this.rowData.id == 4" :rowData="rowData" :propRowData="propRowData" @chooseCategory="chooseCategory" ref="publicRef"></PublicEnvirenment>
        </div>
        <div v-else-if="type == 2">
          <IndustryHazard v-if="this.rowData.id == 1" :industryId="industryId" :categoryData="categoryData" :postList="postList" :propRowData="propRowData" :UUID="UUID" @getcostList="getcostList"></IndustryHazard>
          <EnvironmentIndustry v-else-if="this.rowData.id == 2 || this.rowData.id == 3" :enviromentList="enviromentList" :rowData="rowData" :UUID="UUID" @getcostList="getcostList" ></EnvironmentIndustry>
          <publicIndustry ref="publicIndustry" v-else-if="this.rowData.id == 4" @getcostList="getcostList"></publicIndustry>
        </div>
        <div v-else-if="type == 3">
          <Quoteprice :propRowData="propRowData" :costList="costList" @getQuoteprice="getQuoteprice" :information="information" :informationForm="informationForm" ref="priceRef" :customerInformation="customerInformation"></Quoteprice>
        </div>
      </div>
      <template slot="footer" v-if="this.rowData.id == 1">
        <a-button key="back" @click="closeVisible" v-if="type == 0">取消</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="previous" v-if="type == 2 || type == 3 || type == 1">上一步</a-button>
        <a-button key="submit" @click="getQuotation" v-if="type == 3">生成报价单</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="next" v-if="type == 2 || type == 1" >下一步</a-button>
      </template>
      <template slot="footer" v-else-if="this.rowData.id == 2 || this.rowData.id == 3 || this.rowData.id == 4">
        <a-button key="back" @click="closeVisible" v-if="type == 0">取消</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="previous" v-if="type == 2 || type == 3 || type == 1" >上一步</a-button >
        <a-button key="submit" @click="getQuotation" v-if="type == 3">生成报价单</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="next1" v-if="type == 1">下一步</a-button>
        <a-button key="submit"  type="primary"  :loading="loading"  @click="next"  v-if="type == 2"  
        :disabled="backEnviromentList.length == [] && this.rowData.id == 4">下一步</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import {
  addQuoteInfor,
  postInfo,
  postInfo_details,
  addQuotation,
  addBatch,
  usreInfo,
  postInfo_list,
  getCustomer,
  items_list,
} from '@/api/Industry'
import { generateUUID } from './components/getUUID.js'
import Information from './information/index'
import IndustryHazard from './industryHazard/index'
import Quoteprice from './quoteprice/index.vue'
import EnvironmrntInformation from './components/environmrntInformation.vue'
import EnvironmentIndustry from './components/environmentIndustry.vue'
import PublicEnvirenment from './components/publicEnvironment.vue'
import publicIndustry from './components/industry.vue'

export default {
  components: {
    Information,
    IndustryHazard,
    Quoteprice,
    EnvironmrntInformation,
    EnvironmentIndustry,
    PublicEnvirenment,
    publicIndustry,
  },
  props: [
    'propRowData',
    'generateVisible',
    // 'UUID'
  ],
  data() {
    return {
      // masterCategoryId: undefined,
      isNext: 0,
      enviromentList: [],
      backEnviromentList: [],
      rowData: '',
      UUID: '',
      industryId: '',
      // 项目列表
      categoryNameList: [],
      informationForm: [],
      priceList1: [],
      priceForm: [],
      costList: [],
      postList: [],
      categoryData: [],
      datalist: [],
      information: {},
      customerInformation: {},
      quoteVisible: false,
      type: 0,
      current: 0,
      steps: [
        {
          title: '第一步',
          content: 'First-content',
        },
        {
          title: '第二步',
          content: 'Second-content',
        },
        {
          title: '第三步',
          content: 'Last-content',
        },
        {
          title: '第四步',
          content: 'First-content',
        },
      ],
    }
  },
  created() {
    //查询报价检测项目列表
    items_list().then((res) => {
      if (res.code == 200) {
        this.categoryNameList = res.data
      } else {
        this.$message.error('查询报价检测项目列表失败！')
      }
    })
    // //获取客服信息
    //  customerService_details( this.propRowData.id).then(res => {
    //      console.log(res, 'res=================================')
    //  })
  },
  methods: {
    next1() {
      if (this.rowData.id == 4) {
        this.$refs.publicRef.$refs.categoriesRef.validate((valid) => {
          if (valid) {
            this.UUID = generateUUID(20, 16)
            this.current++
            this.type++
            var data = {
              UUID: this.UUID,
              enviromentList: this.enviromentList,
              rowData: this.rowData,
            }
            this.$nextTick(() => {
              this.$refs.publicIndustry.init(data)
            })
          }
        })
      } else {
        this.$refs.environmentRef.$refs.categoriesRef.validate((valid) => {
          if (valid) {
            this.UUID = generateUUID(20, 16)
            this.current++
            this.type++
          }
        })
      }
    },
    // 环境第二步循环的数组
    chooseCategory(data) {
      console.log(data, 'datadata')
      data.forEach((item) => {
        Object.assign(item, {
          testExpense: 0,
          reportFabrication: '',
          expertEvaluation: '',
          total: '',
        })
      })
      this.enviromentList = JSON.parse(JSON.stringify(data))
      console.log(this.enviromentList, 'this.enviromentListthis.enviromentList')
    },
    chooseCategoryName(row) {
      this.rowData = row
      console.log(this.rowData, ' this.rowData this.rowData this.rowData this.rowData')
      // console.log(e.target.dataset.index)
      console.log(row)
      this.current++
      this.type++
    },
    //获取报价单数据
    getQuoteprice(data) {
      this.priceForm = data

      console.log(this.priceForm, ' this.priceForm==================')
      Object.assign(this.priceForm, {
        id: this.UUID,
      })
    },
    getQuotation() {
      console.log('11111111111111111111111111')
      console.log(this.priceForm, 'this.priceForm=============')
      this.$refs.priceRef.$refs.priceFormRef.validate((valid) => {
        if (valid) {
          // Object.assign(this.priceForm, {
          // masterAbbreviation: this.categoryData.masterAbbreviation
          // companyName:  this.propRowData.companyName,
          // address: this.propRowData.address,
          // customerName: this.propRowData.customerName,
          // telephone: this.propRowData.telephone,
          // email: this.propRowData.email,
          // fixedTelephone: this.propRowData.fixedTelephone,
          // customerId: this.propRowData.customerId

          // })
          // console.log(this.propRowData, 'this.propRowData')
          Object.assign(this.priceForm, {
            masterCategoryId: this.rowData.id,
            masterAbbreviation: this.rowData.abbreviation,
          })
          console.log(this.rowData.id, 'this.rowData======================')
          addQuotation(this.priceForm).then((res) => {
            if (res.code == 200) {
              this.generateVisible = false
              this.type = 1
              this.current = 0
            } else {
              this.$message.error(res.msg)
            }
            console.log(res, 'res888888888888')
          })
        }
      })
    },
    // 上一步事件
    previous() {
      console.log(this.rowData.id, 'this.rowData.id====================')
      if (this.backEnviromentList) {
        this.enviromentList = this.backEnviromentList
      }
      this.current--
      this.type--
      this.$nextTick(() => {
        var data = {
          UUID: this.UUID,
          enviromentList: this.enviromentList,
          rowData: this.rowData,
          backType: 1,
        }
        this.$refs.publicIndustry.init(data)
      })
    },

    getcostList(data) {
      if(this.rowData.id == 4) {
      this.backEnviromentList = data

      }
      console.log(data, 'data=================')
      console.log(data, 'data============================')
      this.costList = []
      this.priceList1 = []
      this.$nextTick(() => {
        this.costList = data
        this.costList.forEach((item) => {
          console.log('11111111111111111111111111')
          if (
            item.costList.reportFabrication != null &&
            item.costList.expertEvaluation != null &&
            item.costList.total != null
          ) {
            Object.assign(item.costList, {
              sheetId: this.UUID,
              //  subId: item.subId,
              subId: item.id,
              subName: item.fullCategory,
              subAbb: item.abbreviationCategory,
            })
            this.priceList1.push(item.costList)
            console.log(item, 'item=====================')

            console.log(this.priceList1, 'this.priceList1=====================')
          } else {
            return
          }
        })
      })

      // this.costList.costList
      // console.log(this.costList.costList, 'this.costList=====')
    },
    //获得关联岗位
    getIndustry(data) {
      this.industryId = data.id
      this.informationList = data
      // postInfo_list({sheetId: this.UUID,
      //   industryId: data.id}).then(res => {
      //   this.postList = res.data
      //   console.log(this.postList, 'this.postList333333333333333333')
      //   res.data.forEach(item => {
      //     postInfo_details(item.id).then(res => {
      //       console.log(res, 'res444444444444444444444444')

      //     })
      //   })

      // })
      console.log(data, 'data33333')
    },
    //获得基本信息表单数据
    transmit(data) {
      console.log('2222222222222222222222')
      console.log(data, 'data========================')
      this.categoryData = []
      this.information = data.informationList
      console.log(this.information, 'this.information========================')
      this.datalist = data.datalist
      for (var i = 0; i < this.information.projectCategory.length; i++) {
        this.datalist.forEach((item) => {
          if (item.id == this.information.projectCategory[i]) {
            //  var obj = []
            //  obj.push(item)
            this.categoryData.push(item)

            console.log(item, 'item==================')
          }
          console.log(this.categoryData, 'data2==================')
        })
        this.categoryData.forEach((item) => {
          Object.assign(item, {
            postData: [],
            costList: {
              testExpense: 0,
              reportFabrication: 0,
              expertEvaluation: 0,
              total: 0,
            },
          })
        })
      }
      // console.log(this.projectCategoryList, 'this.projectCategoryList==================')
    },
    //生成uuid
    //  generateUUID(len,radix) {
    //   var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    //   var uuid = [], i;
    //   radix = radix || chars.length;

    //   if (len) {
    //     // Compact form
    //     for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
    //   } else {
    //     // rfc4122, version 4 form
    //     var r;

    //     // rfc4122 requires these characters
    //     uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    //     uuid[14] = '4';

    //     // Fill in random data.  At i==19 set the high bits of clock sequence as
    //     // per rfc4122, sec. 4.1.5
    //     for (i = 0; i < 36; i++) {
    //       if (!uuid[i]) {
    //         r = 0 | Math.random()*16;
    //         uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
    //       }
    //     }
    //   }
    // console.log(uuid.join(''), 'uuid===============')
    //   return uuid.join('');

    // },
    //下一步事件

    next() {
      console.log(this.type, 'this.type ========================')
      // this.current++;
      // this.type++
      if (this.type == 1) {
        this.$refs.baseRef.$refs.informationRef.validate((valid) => {
          if (valid) {
            this.UUID = generateUUID(20, 16)
            this.current++
            this.type++
          }
        })
      } else if (this.type == 2 && this.rowData.id == 4) {
        if (this.backEnviromentList.length) {
          this.backEnviromentList.forEach((item1) => {
            console.log(item1, 'item1=======================')
            item1.projectList.forEach((item) => {
              if (item.pointNumber == '' || item.pointNumber == null) {
                this.isNext = 1
                this.$message.warning('检测类别的点位数必填！')
                return
              } else {
                this.isNext = 0
              }
            })
          })
        }
        console.log(this.isNext, 'this.isNext=======================')
        if (this.isNext == 0) {
          this.$nextTick(() => {
            var number = 0
            console.log(this.backEnviromentList, 'this.backEnviromentList============')
            for(var i = 0; i < this.backEnviromentList.length; i++) {
              this.$refs.publicIndustry.$refs.categoriesRef[i].validate((valid) => {
                console.log(number, 'number111111111111111')
              if (valid) {
                number ++ 
                  if (valid && number == this.backEnviromentList.length) {
                     console.log(number, 'number2222222222222222222')
                this.priceList1.forEach((item) => {
                  Object.assign(item, {
                    companyName: this.propRowData.companyName,
                  })
                })

                console.log(this.priceList1, 'priceList1=============================')
                // console.log()
                addBatch(this.priceList1).then((res) => {
                  if (res.code == 200) {
                    this.current++
                    this.type++
                    this.$nextTick(() => {
                      console.log(this.$refs.priceRef, ' this.$refs.priceRef')
                      this.$refs.priceRef.init()
                    })
                  } else {
                    this.$message.error(res.msg)
                  }
                  console.log(res, 'res999999999')
                })

                  }
               
              }
            })

            }
            
          })
        }
      } else if(this.type == 2) {
         this.priceList1.forEach(item => {
              Object.assign(item, {
            companyName: this.propRowData.companyName

          })

          })
          addBatch(this.priceList1).then(res => {
            if(res.code == 200) {
            
              this.current++;
              this.type++;
                this.$nextTick(() =>{
                  console.log( this.$refs.priceRef, ' this.$refs.priceRef')
              this.$refs.priceRef.init()
              })
            } else {
              this.$message.error(res.msg)
            }
            console.log(res, 'res999999999')
            

          })
          

      }
    },
    prev() {
      this.current--
    },
    //取消事件
    cancel() {},
    //关闭弹出事件
    closeVisible() {
      this.generateVisible = false
      console.log(this.generateVisible, 'this.generateVisible1111')
      this.$emit('visibleState', this.generateVisible)
      // if(this.type == 3){
      this.type = 0
      this.current = 0
      // }
      //清空当前页面数据
      // 第一步数据
      // this.$refs.baseRef.$refs.informationRef.clearValidate()
      //  this.$refs.baseRef.$refs.informationRef.resetFields()

      // 第二步数据
      // 第三步数据
    },
  },
}
</script>
<style scoped>
.generate_container {
  padding: 10px;
}
.generate_top,
.generate_bottom {
  padding: 15px 15px 0 15px;
  margin: 15px 0;
}
.userContainer {
  background-color: #fff;
  padding: 15px 5px;
  border-radius: 10px;
  padding-left: 10px;
}
.userDetailContaier {
  padding: 0px 24px 24px 24px;
  background-color: #fff;
}
.ant-modal-body {
  background-color: #f8f8f8 !important;
}
.title {
  font-size: 18px;
}
.stepsCenter {
  padding: 20px;
  text-align: center;
}
.box {
  height: 100px;
  width: 70%;
  background: -webkit-linear-gradient(left, #e1eaf3, #a1cdf7, #72b8fa, #49a5fc);
  border-radius: 20px;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
}
.box:nth-of-type(1) {
  margin-left: 20px;
}
.box:focus {
  background-color: #198fff;
  color: #fff;
}
</style>
